export interface ISimpleListSF { title: string, value: string, valueOptional?: string };
